import { useEffect } from 'react'
import { useThemeStore } from '@/stores/themeStore'

/** High-contrast + reduced-motion toggles (WCAG 2.2 AA). */
export function AccessibilityControls() {
  const { highContrast, reducedMotion, toggleHighContrast, setReducedMotion, apply } = useThemeStore()

  useEffect(() => {
    apply()
  }, [apply])

  return (
    <div className="space-y-2 font-ui text-sm text-bone-dim">
      <label className="flex cursor-pointer items-center gap-2">
        <input type="checkbox" checked={highContrast} onChange={toggleHighContrast} className="accent-gold" />
        High contrast
      </label>
      <label className="flex cursor-pointer items-center gap-2">
        <input type="checkbox" checked={reducedMotion} onChange={(e) => setReducedMotion(e.target.checked)} className="accent-gold" />
        Reduce motion
      </label>
    </div>
  )
}
